/*import React, { useEffect, useRef } from "react";
import "./BannerAds.css";

const BannerAds = () => {
  const adRef = useRef(null);

  useEffect(() => {
    if (!adRef.current) return;

    // duplicate ads avoid
    adRef.current.innerHTML = "";

    window.atOptions = {
      key: "66ad8db64bb5757668d1ebe504368151",
      format: "iframe",
      height: 50,
      width: 320,
      params: {},
    };

    const script = document.createElement("script");
    script.type = "text/javascript";
    script.async = true;
    script.src =
      "https://www.highperformanceformat.com/66ad8db64bb5757668d1ebe504368151/invoke.js";

    adRef.current.appendChild(script);

    return () => {
      if (adRef.current) {
        adRef.current.innerHTML = "";
      }
    };
  }, []);

  return (
    <div className="banner-container">
      <div ref={adRef} className="banner-ad-box"></div>
    </div>
  );
};

export default BannerAds;*/

const BannerAds = () => {
  return null;
};

export default BannerAds;